import initialState from "../../store/initialState";

const paymentInitialState = {
	...initialState,
	paymentData: {}
};

export default paymentInitialState;
